import { Component } from '@angular/core';

@Component({
    selector: 'scitis-looker-page',
    templateUrl: './looker-page.component.html',
    styleUrls: ['./looker-page.component.scss'],
    standalone: false
})
export class LookerPageComponent {

  constructor() { }

  

}
